export const GET_REMINDER_REQUEST = "GET_REMINDER_REQUEST";
export const GET_REMINDER_FAILURE = "GET_REMINDER_FAILURE";
export const GET_REMINDER_SUCCESS = "GET_REMINDER_SUCCESS";
